<template>
  <section>
    <nav class="level">
      <div class="level-left">
        <b-input placeholder="Search..." v-model="search_query" type="search" icon="search" icon-pack="fas" width="250"></b-input>
      </div>
      <div class="level-center">
        <div class="level-item">
            
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <div class="buttons">
            <b-button type="is-info" icon-pack="fas" icon-left="print" @click="printpdf()">พิมพ์รายงาน</b-button>
          </div>
        </div>
      </div>
    </nav>

    <h1 class="section-head">สินค้าคงคลัง</h1>

    <div>
      <b-table
        :data="filteredData"
        selectable @click="selected"
        :selected.sync="selectedItem"
        :hoverable="true"
        :loading="isTableLoading"

        :paginated="isPaginated"
        :per-page="perPage"
        :current-page.sync="currentPage"
        :pagination-simple="isPaginationSimple"
        :narrowed="true"
      >
        <template slot-scope="props">
          <b-table-column field="id" label="ID" width="40" numeric>
              {{ props.row.id }}
          </b-table-column>

          <b-table-column field="name"  label="ชื่อผลิตภัณฑ์" width="25%">
              {{ props.row.name }}
          </b-table-column>

          <b-table-column field="sup_name" label="ซัพพลายเออร์" width="25%">
              {{ props.row.sup_name }}
          </b-table-column>

          <b-table-column field="price_sell" label="ราคาซื้อ" width="180">
              {{ parseFloat(props.row.price_buy).formatMoney(2) }}  บาท/{{ props.row.unit_buy_text }}
          </b-table-column>

          <b-table-column field="price_buy" label="คงเหลือ"  width="100">
              {{props.row.in_stock}} {{ props.row.unit_sell_text }}
          </b-table-column>

          <b-table-column field="price_buy" label="มูลค่า"  width="100">
              {{ props.row.in_stock > 0.01 ? parseFloat((props.row.in_stock/props.row.multiply) * props.row.price_buy).formatMoney(2) : 0 }} บาท
           </b-table-column>
        </template>
      </b-table>
      <div class="notification has-text-centered" v-if="all_product.length == 0 && !isTableLoading">ไม่พบข้อมูล</div>
    </div>
  </section>
</template>

<script>
  import ProductModel from '@/model/product_model'
  import Request from '@/libraries/request'
  import Const from '@/const/const'
  import Config from '@/libraries/config'

  export default {
    name: 'Product',
    props: ['supId'],
    data() {
      return {
        all_product: [],
        selectedItem: {},
        lastSelected: {},
        isTableLoading: true,
        isPaginated: true,
        isPaginationSimple: false,
        currentPage: 1,
        perPage: 40,
        search_query: "",
      }
    },
    mounted() {
      this.init();
    },
    computed: {
      filteredData: function() {
        return this.all_product.filter(product => {
          return (
                  (product.code && product.code.toLowerCase().includes(this.search_query.toLowerCase()))
                  || (product.sup_name && product.sup_name.toLowerCase().includes(this.search_query.toLowerCase()))
                  || (product.name && product.name.toLowerCase().includes(this.search_query.toLowerCase()))

                )
        })
      }
    },
    methods: {
      async init(){
        this.all_product = await ProductModel.get_all_product(this.supId);
        this.isTableLoading = false;
      },
      printpdf(){
        window.open(Config.baseUrl +"/v"+Config.version+ "/printpdf/report_inventory", '_blank');
      },
      selected(item) {
        if(this.lastSelected == item){
          this.$router.push({ path: '/product/edit/'+item.id })
        }
        this.lastSelected = item;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .alert-reorder {
    font-weight: bolder;
    color: #FFF;
    background-color: red;
    padding: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Report/inventory.vue